class ManageBrandController {
    constructor($window, $uibModal, UtpBrandServiceApi, toastr, SettingsService, ReportUtils) {
        this.data = {
            availableSims: [],
            allBrands: []
        };
        this.state = {
            clickableEdit: true,
            selectedBrand: null
        };
        this.nameRenderer = (row) => {
            const name = [
                '<span',
                'ng-if="!vm.state.clickableEdit">',
                row.data.Name,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'ng-if="vm.state.clickableEdit"',
                'ng-click="vm.editBrand(data)">',
                row.data.Name,
                '</a>'
            ].join(' ');
            return name;
        };
        this.actionsCellRenderer = () => {
            const edit = [
                '<span class="btn btn-info btn-xs"',
                'ng-click="vm.editBrand(data)"',
                'uib-popover="Edit brand"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="glyphicon glyphicon-pencil"></i>',
                '</span > '
            ].join(' ');
            const assign = [
                '<span class="btn btn-info btn-xs"',
                'ng-click="vm.assignSimsToBrand(data)"',
                'uib-popover="Assign simulators to brand"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="glyphicon glyphicon-transfer"></i>',
                '</span > '
            ].join(' ');
            return '<div class="ag-grid-actions-container">' + edit + assign + '</div>';
        };
        this.columnDefs = [
            {
                headerName: 'Id',
                width: 52,
                minWidth: 52,
                maxWidth: 52,
                field: 'Id',
                hide: false,
                resizable: false,
                suppressMenu: true
            },
            {
                headerName: 'Name',
                width: 650,
                minWidth: 80,
                field: 'Name',
                cellRenderer: this.nameRenderer,
                sort: 'asc',
                suppressMovable: true
            },
            {
                headerName: 'Sims',
                width: 334,
                minWidth: 60,
                field: 'AssignedSimulators.length'
            },
            {
                headerName: 'Actions',
                width: 100,
                maxWidth: 100,
                minWidth: 100,
                cellRenderer: this.actionsCellRenderer,
                sortable: false,
                suppressMenu: true,
                resizable: false,
                suppressMovable: true
            }
        ];
        this.$onInit = () => {
            this.init();
        };
        this.onModelUpdated = () => {
            let processedRows = 0;
            if (this.gridOptions !== undefined) {
                const model = this.gridOptions.api.getModel();
                processedRows = model.getRowCount();
            }
            this.rowCount = processedRows;
        };
        this.assignSimsToBrand = (brand) => {
            // Set row Selected
            this.state.selectedBrand = brand.Id;
            // Open in Modal dialog
            let assignSimToBrandModal = this.uibModal.open({
                animation: true,
                component: 'assignSimsToBrandModalComponent',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    brand: () => {
                        return brand;
                    },
                    availableSims: () => {
                        return this.data.availableSims;
                    }
                }
            });
            assignSimToBrandModal.result.then(
            // close callback
            () => {
                this.toastr.info([
                    brand.Name,
                    ' brand Simulator assignment updated'
                ].join(''));
                this.refreshData();
            }, 
            // dismiss callback
            () => {
                this.toastr.info(['Simulator assignment cancelled!'].join(''));
                this.refreshData();
            });
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.exportCsv = () => {
            // TODO
        };
        this.refreshData = () => {
            this.UtpBrandServiceApi.getAllBrandsAndSims().then((response) => {
                let brands = response.data;
                this.data.allBrands = brands;
                this.gridOptions.api.setRowData(brands);
            });
            // Get all the available sims
            this.UtpBrandServiceApi.getAllUnbrandedSims().then((response) => {
                let sims = response.data;
                this.data.availableSims = sims;
            });
        };
        this.editBrand = (brand) => {
            // Set row Selected
            this.state.selectedBrand = brand.Id;
            // Open in Modal dialog
            // All updates to the database are handled by AddBrandController.
            let brandEditModal = this.uibModal.open({
                animation: true,
                component: 'addEditBrandModalComponent',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    brand: () => {
                        return brand;
                    }
                }
            });
            brandEditModal.result.then(
            // close callback
            (modalResult) => {
                this.toastr.info(['Brand ', modalResult, 'd!'].join(''));
                this.UtpBrandServiceApi.getAllBrandsAndSims().then((response) => {
                    let brands = response.data;
                    this.data.allBrands = brands;
                    this.gridOptions.api.setRowData(response.data);
                });
            }, 
            // dismiss callback
            (modalResult) => {
                this.toastr.info(['Brand update cancelled!'].join(''));
            });
        };
        this.addBrand = () => {
            // Create a new brand
            // Create empty brand to pass to edit brand
            let emptyBrand = { Id: -1, Name: '' };
            // use editBrand to get the new brand
            // details and save
            this.editBrand(emptyBrand);
        };
        this.resetSelection = () => {
            this.gridOptions.api.forEachNode((node) => {
                if (node.data.Id === this.state.selectedBrand) {
                    node.setSelected(true);
                }
                else {
                    node.setSelected(false);
                }
            });
        };
        this.init = () => {
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                // Get all the available sims now to reduce the load at the other end.
                this.UtpBrandServiceApi.getAllUnbrandedSims().then((response) => {
                    let sims = response.data;
                    this.data.availableSims = sims;
                });
                // Initialise, just need to get list of all brands
                this.UtpBrandServiceApi.getAllBrandsAndSims().then((response) => {
                    let brands = response.data;
                    this.data.allBrands = brands;
                    this.gridOptions.api.setRowData(response.data);
                    if (this.state.selectedBrand != null) {
                        this.resetSelection();
                    }
                    // vm.gridOptions.api.sizeColumnsToFit();
                });
            });
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.UtpBrandServiceApi = UtpBrandServiceApi,
            this.toastr = toastr;
        this.SettingsService = SettingsService;
        this.ReportUtils = ReportUtils;
    }
}
angular.module('app').component('manageBrand', {
    bindings: {},
    templateUrl: 'scripts/app/partials/Brand/manage-brand.tpl.html',
    controllerAs: 'vm',
    controller: ManageBrandController
});
